const moodPractitioner = () =>
  import(
    /* webpackChunkName: "moodPractitioner~index" */ 'page/platform/moodPractitioner/index.vue'
  )
const moodPractitionerGuide = () =>
  import(
    /* webpackChunkName: "moodPractitioner~moodPractitionerGuide" */ 'page/platform/moodPractitioner/moodPractitionerGuide.vue'
  )

let routes = [
  {
    path: '/moodPractitioner',
    component: moodPractitioner,
    meta: {
      pageName: '正念打卡',
      business: '平台',
      title: '正念打卡'
    }
  },
  {
    path: '/moodPractitionerGuide',
    component: moodPractitionerGuide,
    meta: {
      pageName: '怎么练规则说明',
      business: '平台',
      title: '怎么练规则说明'
    }
  }
]

export default routes
